import React, { useEffect, useMemo, useState } from "react";
import { BreadCrumbSecttion } from "../component/BreadCrumbSecttion";
import { Container, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import InputField from "../component/InputField";
import PrimaryGradientButton from "../component/PrimaryGradientButton";
import SelectDropDown from "../component/SelectDropDown";
import OtherService from "../services/Other";
import DefaultImage from "../assets/images/logo-small.png";
import RegistrationService from "../services/registration";
import toast from "react-hot-toast";
import {
  isMobileNumberValid,
  validateDoc,
  ValidatePhoneNumber,
} from "../constants/commonFunction";
import Form from "react-bootstrap/Form";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { useSelector, useDispatch } from "react-redux";
import UploadFile from "../component/UploadFile";
import ProfileService from "../services/Profile";
import { addUserData } from "../redux/slices/userTypeSlice";
import ConfirmationModal from "../component/ConfirmationModal";
dayjs.extend(customParseFormat);
const dateFormat = "YYYY-MM-DD";

const NonBypassEKYC = ({catgryId, type, from}) => {
  
  const dispatch = useDispatch();
  const userInfo = JSON.parse(localStorage.getItem("userData")).description;
  const userData =  useSelector(state => state.userTypeSlice.userData);
  const navigate = useNavigate();
  const [frontImage, setFrontImage] = useState(null);
  const [backImage, setBackImage] = useState(null);
  const [isChecked, setIsChecked] = useState(false)
  const [isButtonLoading, setIsButtonLoading] = useState(false);
  const [dob, setDOB] = useState(null);
  const [msg, setMsg] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [documentNum, setDocumentNum] = useState("");
  const [hasPan, setHasPan] = useState(true);
  const [loading, setLoading] = useState(false);
  const [selectedDocType, setSelectedDocType] = useState( {
    title: '',
    id: '',
    val: '',
  },);
    const documentTypeList = useMemo(() => [
      // {
      //   title: 'PAN',
      //   id: 'pan_image',
      //   val: '2',
      // },
      {
        title: 'Driving License',
        id: 'dl_image',
        val: '7',
      },
      {
        title: 'Voter ID',
        id: 'voter_image',
        val: '6',
      },
    ], []);

  useEffect(() => {
    setFrontImage(null)
    setBackImage(null)
    setDocumentNum("")
    
    if(hasPan || type=='pan') {
      setSelectedDocType({
        title: 'PAN',
        id: 'pan_image',
        val: '2',
      })
    } else {
      setSelectedDocType({
        title: '',
        id: '',
        val: '',
      })
    }
  }, [hasPan]);






  const submitHandler = async () => {
    console.log(frontImage, backImage)
        setLoading(true);
        // setOpenModal(true)
        
        setDocumentNum(documentNum.replace(/ /g, "").toUpperCase().trim());
    
        if (!documentNum ) {
          setDocumentNum('');
          toast.error("Please provide document number")
          return;
        }
        // if (documentNum && !validateDoc(selectedDocType.title, documentNum.replace(/ /g, "").toUpperCase().trim())) {
        //   setDocumentNum('');
        //   toast.error("Invalid document type")
        //   return;
        // }

        if (!hasPan && dob.length == 0) {
          toast.error(`Please enter valid DoB`);
          setDOB("");
    
          setLoading(false);
          return;
        }
        
        if ((selectedDocType.val != '2' && (!frontImage || !backImage)) || (type != 'pan' && (!frontImage )) ) {
          toast.error(`Please provide the image of your document`);
    
          setLoading(false);
          return;
        }
    
    
        if ( (selectedDocType.val == '2' && !frontImage) ||(type == 'pan' && !frontImage)) {
          toast.error(`Please provide the image of your document`);
    
          setLoading(false);
          return;
        }
    
        const formData = new FormData();
        
        formData.append(`ekyc_front_image`, frontImage?.file);
        backImage && formData.append(`ekyc_back_image`, backImage?.file);    
        formData.append('KYCType', hasPan ? '2' : selectedDocType.val)
        formData.append('doc_number', documentNum.toUpperCase().trim());
        formData.append('contact_id', userData.contact_id);
        formData.append('organization_Id', '2');
        formData.append('hierarchies_id', userData.hierarchies_id);
    
        if(!hasPan) {
          const [yyyy, mm, dd] = dob.split('-');
          formData.append('dob', `${dd}-${mm}-${yyyy}`);
        }
        ProfileService.uploadAndVerifyEKYC(formData)
          .then(res => {
            setLoading(false)
            // setCheckKyc(1);
            // setFrontImage('');
            setMsg(res?.response?.message ?? '');
            if (res.success == true) {
              if (res?.response?.kycStatus == '1') {
                // EncryptedStorage.setItem('documentExist', '1');
                dispatch(
                  addUserData({ userData : {
                    ...userData,
                    document_exist: '1',}
                  }),
                );
                setMsg(res?.response?.message ?? '');
                setOpenModal(true)
                toast.success("Document verified!")
              } else {
                dispatch(
                  addUserData({ userData : {
                    ...userData,
                    document_exist: res?.response?.kycStatus,}
                  }),
                );
                toast.success("Document submitted!");
                if(from != 'cart') {
                navigate("/landing")
                } else {
                  navigate(`/address-list`);
                }
              }
    
            //   setCustName(res?.response?.KYCDetails?.name ?? '');
            //   setCustDOB(res?.response?.KYCDetails?.dob ?? '');
              // setTimeout(() => {
                // setLoading(false);
                // setOpenModal(true);
              // }, 2000);
            } else {
              if (res?.response?.kycStatus == '2') {
                setOpenModal(true);
              } else {
                toast.error(res?.response?.message)
              }
    
            //   setLoading(false);
            }
          })
          .catch(err => {
            setOpenModal(false);
            toast.error("Something went wrong")
          });
        // setCheckKyc(p => p + 1);
  };

  const today = new Date().toISOString().split("T")[0]; // max
    const fifteenDaysAgo = new Date(new Date().setDate(new Date().getDate() - 15))
        .toISOString()
        .split("T")[0]; // min
    
    const minDate = dayjs(fifteenDaysAgo, "YYYY-MM-DD");
    const maxDate = dayjs(today, "YYYY-MM-DD");
    const disabledDate = (current) => {
      return current > maxDate.endOf("day");
    };

    function onReviewSubmit(res) {

      if (res == 'Yes') {
        setOpenModal(false);
        if(from != 'cart') {
          navigate(`/rewards-category-list/${catgryId}`);
        } else {
          navigate(`/address-list`);
        }
      } else {
        setOpenModal(false);
      }
    }

  return (
    <>
      {/* {loading && <Loader />} */}
      <BreadCrumbSecttion
        pageTitle="EKYC Update"
        currentPageName="EKYC Update"
      />
      <section className="padTop50">
        <Container>
          <Row className="justify-content-center align-item-center h-100">
            <Col xs={12}>
              <div className="userInfoBox">
                <div className="dashboard-title">
                  {userData?.document_exist == '2' && (
                    <h4 className="gradient-text">
                      Your last uploaded KYC document has been rejected. Please
                      upload again to continue redemption
                    </h4>
                  )}
                  {userData?.document_exist == '0' && (
                    <h4 className="gradient-text">
                      APPROVAL OF YOUR KYC DOCUMENT IS PENDING, PLEASE CONTACT
                      YOUR OFFICER FOR MORE DETAILS.
                    </h4>
                  )}
                </div>
                {(userData?.document_exist == '2' || userData?.document_exist == 'null' || type == 'pan') && <div className="dashboard-details">
                  <Row>

                    {!hasPan && <Col xs={12} lg={6}>
                      <SelectDropDown
                        labelName="Document Type"
                        requiredStar="*"
                        options={documentTypeList}
                        selectedValue={selectedDocType}
                        setSelectedValue={setSelectedDocType}
                        // onChange={handleServiceChange}
                        // page="searchFilter"
                      />
                    </Col>}
                    <Col xs={12} lg={6}>
                      <InputField
                        requiredStar="*"
                        inputFieldLabel={hasPan ? "PAN Number" : `${!selectedDocType.title ? "Document" :  selectedDocType.title} Number`}
                        name="doc"
                        value={documentNum}
                        // onChange={handleServiceRegistrationInput}
                        setValue={setDocumentNum}
                      />
                      {/* {customerNameValidationError &&
                                                <div className="error-message">
                                                    {customerNameValidationError}
                                                </div>
                                            } */}
                    </Col>
                    <Col xs={12} lg={6}>
                        <UploadFile
                        //   key={`profile-${selectedKYC.id || ''}`}
                          label={hasPan ? 'PAN Image' : `${!selectedDocType.title ? "Document" :  selectedDocType.title} Front Image`}
                          requiredStar="*"
                          accept="image/jpeg, image/jpg, image/png"
                          value={frontImage}
                          setValue={setFrontImage}
                        />
                    </Col>
                    {!hasPan && <Col xs={12} lg={6}>
                        <UploadFile
                        //   key={`profile-${selectedKYC.id || ''}`}
                          label={hasPan ? 'PAN Image' : `${!selectedDocType.title ? "Document" :  selectedDocType.title} Back Image`}
                          requiredStar="*"
                          accept="image/jpeg, image/jpg, image/png"
                          value={backImage}
                          setValue={setBackImage}
                        />
                    </Col>}
                   { !hasPan && <Col xs={12} lg={6} className="mb-3">
                      <Form.Label>DOB</Form.Label>
                      <DatePicker
                        // defaultValue={serviceRegistrationData.serviceDate}
                        format={dateFormat}
                        disabledDate={disabledDate}
                        onKeyDown={(e) => e.preventDefault()}
                        className="w-100"
                        // onChange={handleServiceRegistrationInput}
                        value={dob ? dayjs(dob, dateFormat) : null}
                        onChange={(date, dateString) => setDOB(dateString)}
                        style={{ height: "43px" }}
                        required={true}
                      />
                    </Col>}

                    
                    {/* <Col xs={12} lg={3}>

                                            {showAlert && <AlertMsg alertBoxColor={isLoginSuccess.isLogin ? 'successAlert' : 'FailedAlert'}
                                                heading={isLoginSuccess.heading}
                                                text={isLoginSuccess.text}
                                            />
                                            }
                                        </Col> */}
                  </Row>
                  <Row>
                  <Col xs={12}>
                      <div className="my-3 checkTxt">
                        <input
                          type="checkbox"
                          className="checkTxtBox"
                          checked={isChecked}
                          onChange={() => setIsChecked(p => !p)}
                        />
                        <span className="mx-2">
                        I confirm that details entered above are
                        as per document provided.
                        </span>
                      </div>
                    </Col>
                  <Col xs={12} lg={3}>
                      <PrimaryGradientButton
                        buttonText={
                          isButtonLoading ? "Processing..." : "Submit"
                        }
                        disabled={(isButtonLoading || !isChecked)}
                        className={"mt-2"}
                        onClick={submitHandler}
                      />
                    </Col>
                  {type !== 'pan' && <Col xs={12} lg={3}>
                      <PrimaryGradientButton
                        buttonText={
                          hasPan ? "I Don't Have PAN" : "I have PAN"
                        }
                        disabled={isButtonLoading}
                        className={"mt-2"}
                        onClick={() => setHasPan(p => !p)}
                      />
                    </Col>}
                  </Row>
                </div>}
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <ConfirmationModal isModalOpen={openModal} setIsModalOpen={setOpenModal} page={"dynamicKyc"} modalTitle={"EKYC"} modalDescription={msg} onReviewSubmit={onReviewSubmit}  />
    </>
  );
};

export default NonBypassEKYC;
